import API from '../utils/api';
import config from '../../config';
import { gotoLogin } from './redirect';

export const SESSION_GET = 'SESSION_GET';
export const SESSION_GET_SUCCESS = 'SESSION_GET_SUCCESS';
export const SESSION_GET_FAILED = 'SESSION_GET_FAILED';
export const SESSION_POST = 'SESSION_POST';
export const SESSION_POST_SUCCESS = 'SESSION_POST_SUCCESS';
export const SESSION_POST_FAILED = 'SESSION_POST_FAILED';
export const SESSION_RESET = 'SESSION_RESET';

export const getSession = () => ({
    type: SESSION_GET
});

export const getSessionSuccess = (user) => ({
    type: SESSION_GET_SUCCESS,
    user
});

export const getSessionFailed = (error) => ({
    type: SESSION_GET_FAILED,
    error
});

export const postSession = () => ({
    type: SESSION_POST
});

export const postSessionSuccess = (token) => ({
    type: SESSION_POST_SUCCESS,
    token
});

export const postSessionFailed = (error) => ({
    type: SESSION_POST_FAILED,
    error
});

export const sessionReset = () => (
    {
        type: SESSION_RESET
    }
);

export const getSessionApi = () => (dispatch) => {
    dispatch(getSession());

    return API.post('auth/info', {}).then((res) => {
        if (res.ok) {
            res.json().then((json) => {
                dispatch(getSessionSuccess(json));
            });
        } else {
            res.json().then(json => {
                var error = {
                    error: json.message,
                    error_description: json.message
                }
                dispatch(getSessionFailed(error));
                dispatch(gotoLogin());
                return;
            })
        }
        
    }).catch((error) => {
        console.log(error);
        dispatch(postSessionFailed());
    });
};

export const postSessionApi = (data) => (dispatch) => {
    dispatch(postSession());

    let host = location.hostname;
    let splitHost = host.split('.');
    let tenant = config.defaultTenant;

    if (splitHost[0] !== 'localhost') {
        // for localhost ip testing
        if (splitHost[0] !== '192') {
            tenant = splitHost[0];
        }
    }

    console.log(tenant);
    let credentials = {
        username: data.email,
        password: data.password,
        grant_type: 'tenant',
        client_id: tenant,
        client_secret: 'medix-web-app-client'
    };

    return API.post('auth', credentials).then((res) => {
        if (res.status === 200) {
            res.json().then((json) => {
                dispatch(postSessionSuccess(json.access_token));
                dispatch(getSessionApi());
            });
        } else {
            res.json().then(error => {
                dispatch(postSessionFailed(error));
                return;
            })
        }

    }).catch((error) => {
        console.log(error);
        dispatch(postSessionFailed());
    });
};


/** WEBPACK FOOTER **
 ** ./src/actions/session.js
 **/